import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PNG, SVG_MUI } from "@ryde/assets";
import { useApplication, useRtl } from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import "./reset-password.page.css";

import { ResetPasswordPageForm } from "./reset-password.page.form";
import {
  CopyrightLine,
  LeftImageResetPassword,
  MainResetPasswordContainerStyled,
} from "./reset-password.page.styled";

export const ResetPasswordPage: FC = () => {
  const { isAdminApp } = useApplication();
  const { isMobile } = useIsMobile();
  const { direction } = useRtl();
  const { t } = useTranslation();
  return (
    <MainResetPasswordContainerStyled dir={direction}>
      {!isMobile && (
        <LeftImageResetPassword $isAdminApp={isAdminApp}>
          <SVG_MUI.LogoLoginSVG className="logo" />
          <img src={PNG.LoginLogoPNG} alt="logo" />
        </LeftImageResetPassword>
      )}
      <ResetPasswordPageForm />
      {!isMobile && (
        <CopyrightLine>
          <div>{t("ui.COPYRIGHT_INFO")} </div>
        </CopyrightLine>
      )}
    </MainResetPasswordContainerStyled>
  );
};
